import { Dictionary } from "lodash";
import { DataLogModel, VariableDataModel, VariableModel } from "../../..//apis";

export interface ITreatmentMonitoring {
  treatmentRequestId?: string;
  treatmentNumber?: string;
  unitId?: string;
  unitName?: string;
  freeText?: string;
  zone?:number;
  unitType?:string;
  locationName?: string;
  locationId?: string;
  status?: string;
  autoStopDate?: string;
  remainingO2DownTime?: number;
  remainingO2DownType?: string;
  variableO2Up?: VariableDataModel;
  inProgress?: boolean;
  variableStartStop?: VariableDataModel;
  variableGreenButton?: VariableDataModel[];
  variables?: VariableDataModel[];
  variablesOrigin?: VariableDataModel[];
  variablesIcon?: VariableDataModel[];
  variablesDropdown?: VariableModel[];
}
export interface ITreatmentMonitoringDetail {
  number: Dictionary<string[]>;
  bool: Dictionary<string[]>;
}

export interface DataLogModelWrapper extends DataLogModel {
  id?: string;
}

export interface IDataLog {
  date: string;
  time: string;
  treatmentId: string;
  dataLogs: Dictionary<DataLogModelWrapper[]>;
}

export const DUMMY_CHART = require("./chart.json");

export const msToVariableTime = (delta: number): string => {

  const padStart2 = (val: number): string => {
    return ("" + val).padStart(2, "0");
  };

  const days = Math.floor(delta / 86400);
  delta -= days * 86400;
  const hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;
  const minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;
  const seconds = delta % 60;
  return `${padStart2(days)}${padStart2(hours)}${padStart2(minutes)}${padStart2(seconds < 1 ? 0 : seconds)}`;
};
